import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { ShopCenterPagination } from "../shop/ShopCenterPagination";
import { InvoicesList } from "./InvoicesList";
import { ListSkeleton } from "../common/Skeletons";
import { EmptyState } from "../common/EmptyState";

import '../../styles/Invoices.scss';

import InvoicesService from "../../services/invoicesService";
import { Header } from "../common/Header";
import { TopBar } from "../common/TopBar";


/**
 * Renders information about the user obtained from MS Graph
 * @param props 
 */
export const Invoices = (props) => {

    let invoicesBase = {
        result: [],
        pages: [],
        totalPages: 0,
        totalCount: 0,
        page: 1,
        pageSize: 30
    };


    const orderService = InvoicesService();
    const [invoices, setInvoices] = useState(invoicesBase);
    const [orderLoaded, setInvoiceLoaded] = useState(false);
    const [filter, setFilter] = useState({
        page: invoicesBase.page,
        pageSize: invoicesBase.pageSize,
    });

    const [totPages, setTotPages] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(30);

    const [showItem, setShowItem] = useState(false);

    useEffect(() => {

        const initState = async () => {
            setInvoiceLoaded(false);
            const allInvoices = await orderService.getInvoices(filter.page, filter.pageSize);
            setInvoices(allInvoices);
            invoicesBase = allInvoices;
            setTotPages(allInvoices.totalPages);
            setPage(allInvoices.page);
            setPageSize(allInvoices.pageSize);
            setFilter({
                totalCount: allInvoices.totalCount,
                totalPages: allInvoices.totalPages,
                page: allInvoices.page,
                pageSize: allInvoices.pageSize,
                pages: allInvoices.pages,
            });


            setInvoiceLoaded(true);
            setShowItem(false);

        };
        initState();
    }, []);

    const updateInvoices = async (a) => {
        setInvoiceLoaded(false);

        setInvoices(await orderService.getInvoices(a, pageSize));

        setFilter({
            page: invoicesBase.page,
            pageSize: invoicesBase.pageSize,
        });

        setInvoiceLoaded(true);
        setShowItem(false);
    }

    const onPageChange = (newPage) => {
        if (page != newPage) {
            console.log("onPageChange", newPage, page);
            setPage(newPage);

            updateInvoices(newPage);
            setShowItem(false);
        }
    };



    const hasInvoices = invoices.result && invoices.result.length > 0;
    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
            <Header />
            <TopBar />
            <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>
                {!showItem && (
                    <Typography variant="h5" align="center" sx={{ fontWeight: 800, mb: 3 }}>
                        Invoices
                    </Typography>
                )}
                {!orderLoaded ? (
                    !showItem && <ListSkeleton rows={6} columns={6} />
                ) : hasInvoices ? (
                    <>
                        {!showItem && (
                            <Container>
                                <Row>
                                    <ShopCenterPagination
                                        totPages={totPages}
                                        currentPage={page}
                                        pageClicked={(ele) => onPageChange(ele)}
                                    />
                                </Row>
                            </Container>
                        )}
                        <InvoicesList
                            invoices={invoices}
                            filter={filter}
                            onPageChange={onPageChange}
                            showItem={showItem}
                            setShowItem={setShowItem}
                        />
                    </>
                ) : !showItem ? (
                    <EmptyState
                        icon={<ReceiptLongOutlinedIcon />}
                        title="No invoices yet"
                        description="Your posted invoices will appear here. You can download a PDF copy of each invoice."
                    />
                ) : null}
            </Box>
        </Box>
    );
};